/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade sec
 * ret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function(categoryId) {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllLocationOfficeTypeLookup: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: ['GetAllLocationOfficeTypeLookupResponse.DP_LU_LocationOfficeType'],
    blueprint: {
      officeTypeList: [
        '$..DP_LU_LocationOfficeType',
        {
          officeTypeId: '$..ID',
          officeType: '$..OfficeType',
          categoryId: '$..CategoryID'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);

      response.officeTypeList = _.where(response.officeTypeList, { categoryId: categoryId });

      deferred.resolve(response.officeTypeList);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
